<template>
    <!-- 单产品排名查询 -->
    <div
        v-loading.fullscreen.lock="loading"
        class="production-ranking-query"
        :element-loading-text="loadingText"
        element-loading-background="rgba(0, 0, 0, .5)"
        element-loading-custom-class="loading-style"
        element-loading-spinner="el-icon-loading"
    >
        <notice showIcon
            >现排名查询每天只能查100个关键词，今日已查<em> {{ usedNum }} </em>/100。</notice
        >

        <query-settings
            ref="querySettings"
            :rest-num="totalNum - usedNum"
            :query-type="1"
            @search="search"
            @getPageRange="getPageRange"
        >
            <div class="production-info dfc">
                <div class="title">输入产品链接：</div>
                <p class="production-link textOver">
                    <el-input v-model="proLink" size="medium" placeholder="请输入产品的链接地址" />
                </p>
                <el-button type="primary" size="medium" style="margin-left: 10px" @click="choose"
                    >历史记录选择</el-button
                >
            </div>
        </query-settings>
        <div v-show="pluginInstall">
            <rankListV2
                v-show="isShowList"
                ref="rankListV2"
                :link-to-analysis="linkToAnalysis"
                :table-data="tableData"
                :query="query"
                :show-pagination="true"
                @pageChange="pageChange"
                :productAnalysisPath="productAnalysisPath"
                :isUseNew="isUseNew"
                s
            />
        </div>

        <div v-show="!pluginInstall">
            <rankList
                v-show="isShowList"
                ref="rankList"
                :link-to-analysis="linkToAnalysis"
                :table-data="tableData"
                :query="query"
                :show-pagination="showPagination"
                @pageChange="pageChange"
                :productAnalysisPath="productAnalysisPath"
                :isUseNew="isUseNew"
            />
        </div>
        <historyRecordselect ref="historyRecordselect" @getLink="getLink" />
    </div>
</template>

<script>
import querySettings from '../components/querySettings';
import historyRecordselect from '../components/historyRecordselect';
import rankList from '../components/rankList';
import rankListV2 from '../components/rankListV2.vue';
import { dataAnalysis } from '../common/dataAnalysis';
import notice from './../../../components/notice/index.vue';
import pluginsAnalysis from '../common/pluginsAnalysis';
export default {
    name: 'ProductionRankingQuery',
    components: { querySettings, historyRecordselect, rankList, notice, rankListV2 },
    mixins: [dataAnalysis, pluginsAnalysis],
    props: {
        linkToAnalysis: {
            type: Boolean,
            default: true,
        },
        checkVersion: Function,
        productAnalysisPath: {
            type: String,
            default: '/productAnalysis',
        },
        isUseNew: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            proLink: '',
            showPagination: false,
            queryPage: 0,
        };
    },
    created() {
        judgeDazeCollector({
            name: '排名查询',
            operate: '单产品排名查询进入',
            tag: '',
            value: '',
        });
    },
    methods: {
        // 产品链接转化产品Id
        linkToOfferId(link) {
            let offerId = null;
            if (link.replace(/[\r\n]/g, '') != ' ' && link != '') {
                if (link.indexOf('.html') == -1 || link.indexOf('/offer/') == -1) {
                    return offerId;
                }
                var start = link.indexOf('/offer/') + 7;
                var end = link.indexOf('.html');
                offerId = link.substring(start, end);
            }
            return offerId;
        },
        isOfferId(offerId) {
            const pattern = /[^0-9]/g;
            if (offerId == null || pattern.test(offerId)) {
                return false;
            }
            return true;
        },
        getLink(link) {
            this.proLink = link;
        },
        search(keywords, portPagesValue) {
            this.queryPage = portPagesValue;
            if (this.checkVersion()) {
                return;
            }
            if (this.proLink === '') {
                this.$message.warning('请先填写产品链接！');
                return;
            }
            const offerId = this.linkToOfferId(this.proLink);
            if (!this.isOfferId(offerId)) {
                this.$message.warning('请输入正确的产品链接地址！');
                return;
            }
            this.offerId = offerId;
            this.showPagination = false;
            if (this.pluginInstall) {
                // 插件查询
                this.saveRankedQuery({ keywords });
            } else {
                this.beginStart(keywords);
            }
            // 自动保存一次产品链接 存到历史记录里面
            this.$ajax.post('app/ca/saveproduct', { offerId }).then(() => {});
        },

        choose() {
            if (this.checkVersion()) {
                return;
            }
            this.$refs.historyRecordselect.show();
        },
    },
};
</script>

<style lang="scss" scoped>
.production-ranking-query {
    .production-info {
        .title {
            width: 100px;
            text-align: right;
        }
        .production-link {
            width: 350px;
        }
    }
}
</style>
